import { Badge, Tooltip } from '@chakra-ui/react';
import { useDiffing } from './hooks/useDiffing';
import { EventType } from 'src/gql/graphql';

type DiffTextProps = {
  oldValue?: string;
  newValue?: string;
  compact?: boolean;
};

export function DiffText({
  oldValue,
  newValue,
  compact = false,
}: DiffTextProps) {
  const { getTextColor, getEventType } = useDiffing();

  const eventType = getEventType({ old: oldValue, new: newValue });

  if (!eventType) {
    return <span>{newValue}</span>;
  }

  switch (eventType) {
    case EventType.Modified:
      return compact ? (
        <Tooltip label={`${oldValue} -> ${newValue}`}>
          <Badge
            colorScheme="orange"
            textTransform={'none'}
            size="xs"
            fontSize={'xs'}
            borderRadius={'md'}
            maxWidth="fit-content"
            noOfLines={1}
            wordBreak="break-all"
          >
            {newValue}
          </Badge>
        </Tooltip>
      ) : (
        <div style={{ color: getTextColor(eventType), display: 'inline' }}>
          <span style={{ textDecoration: 'line-through' }}>{oldValue}</span>
          <span> → </span>
          <span style={{ fontWeight: 'bold' }}>{newValue}</span>
        </div>
      );
    case EventType.Created:
      return (
        <Badge
          colorScheme="green"
          textTransform={'none'}
          size="xs"
          fontSize={'xs'}
          borderRadius={'md'}
          width="fit-content"
        >
          {newValue}
        </Badge>
      );
    case EventType.Deleted:
      return (
        <Badge
          colorScheme="red"
          textTransform={'none'}
          size="xs"
          fontSize={'xs'}
          borderRadius={'md'}
          width="fit-content"
        >
          {oldValue}
        </Badge>
      );
    default:
      return <span>{newValue}</span>;
  }
}
